import { getKinsCircleConstitution } from '@/lib/governor/KinsCircleConstitution';

export interface GovernorRelationshipObservation {
  timestamp: string;
  subsystem: 'Relationships';
  status: 'HEALTHY' | 'WARNING' | 'FAILURE';
  observation: string;
  evidence: string;
}

export function runGovernorRelationshipAgent(runtime: any = {}) {
  const observations: GovernorRelationshipObservation[] = [];
  const constitution = getKinsCircleConstitution();
  const constitutionRules = Array.isArray(constitution) ? constitution : [];
  const hasCoParentRule = constitutionRules.some((rule: any) =>
    `${rule?.id ?? ''} ${rule?.title ?? ''} ${rule?.rule ?? ''} ${rule?.description ?? ''}`.toLowerCase().includes('co-parent')
  );
  const hasModernFamilyRule = constitutionRules.some((rule: any) =>
    `${rule?.id ?? ''} ${rule?.title ?? ''} ${rule?.rule ?? ''} ${rule?.description ?? ''}`.toLowerCase().includes('modern')
  );

  observations.push({
    timestamp: new Date().toISOString(),
    subsystem: 'Relationships',
    status: constitutionRules.length > 0 ? 'HEALTHY' : 'FAILURE',
    observation: constitutionRules.length > 0
      ? 'Relationship Integrity live check is connected to the KinsCircle Constitution.'
      : 'Relationship Integrity live check is missing KinsCircle Constitution rules.',
    evidence: `GovernorRelationshipAgent active; constitutionRules=${constitutionRules.length}; coParentRule=${hasCoParentRule}; modernFamilyRule=${hasModernFamilyRule}; co-parent, spouse, in-law, child, sibling, and branch placement checks must follow Constitution authority.`
  });

  return observations;
}
